import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import bankIcon from '../../../../assets/reimbursement-method/bank.svg';
import checkIcon from '../../../../assets/reimbursement-method/check.svg';
import starBadge from '../../../../assets/reimbursement-method/star.svg';
import checkGreen from '../../../../assets/reimbursement-method/check-green.svg';

import { REIMBURSEMENT_OPTION_TYPE } from '../claimbot.constants';

import styles from './ReimbursementMethodOptionsSelector.module.css';

const ReimbursementMethodOptionsSelector = ({
  onOneOptionSelected = () => { },
  optionSelected = null,
  twoOptions = {},
}) => {
  const { t } = useTranslation('fileClaimbot');
  const { leftOption, rightOption } = twoOptions;

  const depositOption = [leftOption, rightOption]
    .find((opt) => opt?.id === REIMBURSEMENT_OPTION_TYPE.ACH);
  const checkOption = [leftOption, rightOption]
    .find((opt) => opt?.id === REIMBURSEMENT_OPTION_TYPE.CHECK);

  const isSelected = (option) => option?.id === optionSelected?.id
    && option?.label === optionSelected?.label;

  // matches the legacy TwoOptionsSelector behavior: rightOption is always
  // reported as the "valid" pick, regardless of which card it renders as
  const onPress = useCallback((option) => () => {
    const validStep = option.id === rightOption?.id
      && option.label === rightOption?.label;

    onOneOptionSelected({ option, validStep });
  }, [rightOption]);

  useEffect(() => {
    // deposit option as default selection in the begining
    onPress(depositOption)();
  }, []);

  return (
    <div className={styles.container}>
      <button
        className={`${styles.card} ${styles.cardRecommended} ${
          isSelected(depositOption) ? styles.cardSelected : ''}`}
        onClick={onPress(depositOption)}
        type="button"
      >
        <span className={styles.radio} />

        <span className={styles.iconWrapper}>
          <img alt="" className={styles.icon} src={bankIcon} />

          <img alt="" className={styles.iconBadge} src={starBadge} />
        </span>

        <div className={styles.cardContent}>
          <span className={styles.cardTitle}>{depositOption?.label}</span>

          <div className={styles.bulletRow}>
            <span className={styles.bullet}>
              <img alt="" src={checkGreen} />

              {t('reimbMethodOptions.directDeposit.fundsTime')}
            </span>

            <span className={styles.bullet}>
              <img alt="" src={checkGreen} />

              {t('reimbMethodOptions.directDeposit.automatic')}
            </span>
          </div>
        </div>

        <span className={styles.recommendedBadge}>
          {t('reimbMethodOptions.recommended')}
        </span>
      </button>

      <button
        className={`${styles.card} ${isSelected(checkOption)
          ? styles.cardSelected : ''}`}
        onClick={onPress(checkOption)}
        type="button"
      >
        <span className={styles.radio} />

        <img alt="" className={styles.icon} src={checkIcon} />

        <div className={styles.cardContent}>
          <span className={styles.cardTitle}>{checkOption?.label}</span>

          <span className={styles.tag}>
            {t('reimbMethodOptions.check.deliveryTime')}
          </span>
        </div>
      </button>
    </div>
  );
};

export { ReimbursementMethodOptionsSelector };
